import moment from "moment"

// Set to the first recomputed day once the backend runbook records it (frontend plan Task 4).
export const DEVICE_DETAILS_AVAILABLE_FROM = null

export const DEVICE_TABS = [
  { key: "device", label: "Devices", column: "Device", exportType: "device" },
  { key: "source", label: "Listening source", column: "Source", exportType: "listening-source", expandable: true }
]

export const formatDetailDate = (iso) => moment(iso).format("D MMM YYYY")

export const datasetFromResponse = (stats) => {
  const hasDetails = !!stats.details_from

  return {
    device: stats.device_stats,
    deviceType: hasDetails ? (stats.device_type_stats ?? null) : null,
    source: hasDetails ? (stats.source_stats ?? null) : null,
    deviceDetails: hasDetails ? { from: stats.details_from, coverage: stats.details_coverage } : null
  }
}

export const hasDetail = (deviceDetails) => !!deviceDetails

export const visibleTabs = (deviceDetails) => (hasDetail(deviceDetails) ? DEVICE_TABS : DEVICE_TABS.slice(0, 1))

export const normalizeRows = (rows) => (rows || []).map((row) => (row.device ? row : { ...row, device: row.source }))

export const rowsForTab = (dataset, tabKey) => normalizeRows(dataset[tabKey])

// Missing coverage counts as full, as in detailCaption.
const fullyDetailed = (deviceDetails) =>
  !!deviceDetails && (typeof deviceDetails.coverage !== "number" || deviceDetails.coverage >= 1)

// The Devices tab shows the finer device-type split (iPad, Android Tablet) only when it covers the whole
// period, and in both periods when comparing; otherwise the legacy rows, which cover every day.
export const devicesDataKey = (primaryDetails, comparisonDetails = null, comparing = false) =>
  fullyDetailed(primaryDetails) && (!comparing || fullyDetailed(comparisonDetails)) ? "deviceType" : "device"

export const agentRows = (row) => (row.agents || []).map((agent) => ({ name: agent.name, cnt: agent.stats.cnt }))

const coveragePercent = (coverage) => Math.min(99, Math.max(1, Math.round(coverage * 100)))

export const detailCaption = (deviceDetails, availableFrom = DEVICE_DETAILS_AVAILABLE_FROM) => {
  if (!deviceDetails) {
    if (!availableFrom) return null
    return `Detailed device and listening-source breakdown is available for periods from ${formatDetailDate(availableFrom)}.`
  }
  if (typeof deviceDetails.coverage !== "number" || deviceDetails.coverage >= 1) return null

  return `Detail covers ${coveragePercent(deviceDetails.coverage)}% of the sessions in this period (days from ${formatDetailDate(deviceDetails.from)}).`
}

export const comparisonCaption = (primaryDetails, comparisonDetails, comparisonHasRows) => {
  if (!primaryDetails || !comparisonHasRows) return null
  if (!comparisonDetails) return "The comparison period has no detailed breakdown, so no comparison is shown on this tab."
  if (typeof comparisonDetails.coverage !== "number" || comparisonDetails.coverage >= 1) return null

  return `Detail for the comparison period covers ${coveragePercent(comparisonDetails.coverage)}% of its sessions (days from ${formatDetailDate(comparisonDetails.from)}), so changes on this tab partly reflect coverage.`
}

export const devicesComparisonCaption = (primaryDetails, comparisonDetails, comparisonHasRows) => {
  if (!primaryDetails || comparisonDetails || !comparisonHasRows) return null

  return `Apps that do not report an operating system are attributed to their platform from ${formatDetailDate(primaryDetails.from)}; the comparison period shows them under Others.`
}
